import { State } from '../state';

export const DocumentDownloadSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    documentdownload: (state: State) => state.DocumentDownload,
};
